import { computed, Ref } from 'vue';
import { type Cell, getCellStart } from './Cell'
import { type Disabled, useDisabledList } from './Disabled'
import { type Period, usePeriodList } from './Period'
import { useTimeZone } from '../tz';

function isBeforeDeadLine(cellOrDate: Cell | Date, timezone?: string, shift = 0) {
	const now = timezone ? useTimeZone(new Date(), timezone) : new Date();
	const deadline = new Date(+now + shift);
	return getCellStart(cellOrDate) <= deadline;
}

export function useCalendar({ disabled, periods, timezone, timeOffset, deadLineAdd }: {
	disabled: Ref<Disabled[]>
	periods: Ref<Period[]>
	timezone: Ref<string>
	timeOffset: Ref<number>
	deadLineAdd: Ref<number>
}) {
	const disabledList = computed(() => useDisabledList(disabled.value));
	const periodList = computed(() => usePeriodList(periods.value, timeOffset.value));

	/** Вроде как, проверка на полное вхождение от начала */
	function getAvailableSubset(cell: Cell): Cell {
		const { error: periodDisabled, periodEnd } = periodList.value.checkPeriod(cell)
		if (periodDisabled && periodEnd) return { from: cell.from, to: periodEnd };

		const disabledListItem = disabledList.value.findInDisabledList(cell);
		if (disabledListItem?.from) return { from: cell.from, to: disabledListItem.from };

		return cell;
	}

	function isCellDisabled(cellOrDate: Cell) {
		if (isBeforeDeadLine(cellOrDate, timezone.value, deadLineAdd.value)) return true;
		if (disabledList.value.findInDisabledList(cellOrDate)) return true;
		return periodList.value.checkPeriod(cellOrDate).error;
	}

	function isCellDisabledAvailability(cellOrDate: Cell) {
		const disableListItem = disabledList.value.findInDisabledList(cellOrDate, false);

		return {
			disabled: isCellDisabled(cellOrDate),
			disabledItemAvailability: disableListItem?.availability
		}
	}

	return {
		getAvailableSubset,
		isCellDisabled,
		isCellDisabledAvailability,
	};
}

export type Calendar = ReturnType<typeof useCalendar>;